import { useStyles } from './styles';
import AppNumberInput from 'components/FormElements/AppNumberInput';
import { round } from 'lodash';

type Props = any; //TODO: define types

const TotalSaleValueCell: React.FC<Props> = ({
  cell,
  setOverride,
  disableTable,
}) => {
  const { classes } = useStyles();

  // Ensure totalSaleValue is never NaN
  const totalSaleValue = Number(cell.totalSaleValue) || 0;

  const suggestedShares =
    Number(cell.suggestedSharesAllocatedForSale) ||
    Number(cell.sharesAllocatedForSale) ||
    0;

  const defaultValue =
    Number(cell.previousGrossReceivedValue ?? 0) +
    Number(
      cell.additionalGrossReceivedValue ??
        suggestedShares * Number(cell.sharePrice),
    );

  const diff = Math.abs(round(totalSaleValue - defaultValue, 2));
  const isInputChanged = diff > 0.01;
  const className = isInputChanged ? classes.inputChanged : '';

  return (
    <AppNumberInput
      key={`total-sale-${cell.shareholdingId}`}
      disabled={disableTable}
      decimals={2}
      placeholder="0"
      defaultValue={0}
      min={0}
      currencyStartAdornment
      value={totalSaleValue}
      onChange={(newValue) => {
        setOverride(cell.shareholdingId, {
          totalSaleValue: Number(newValue) || 0,
        });
      }}
      className={className}
    />
  );
};

export default TotalSaleValueCell;
